import React from 'react';
import styles from '../../../../styles/usageRights.module.css';
import { UsageRightStatus } from '../types';

interface UsageRequestTagProps {
  status: UsageRightStatus;
}

const colorMap = {
  accepted: { text: 'Request Accepted', color: 'var(--text-success)' },
  rejected: { text: 'Request Rejected', color: 'var(--text-critical)' },
  pending: { text: '', color: '' },
  negotiation: { text: '', color: '' },
};

function UsageRequestTag({ status }: UsageRequestTagProps) {
  return (
    <div style={{ color: colorMap?.[status]?.color }} className={styles.usageRequestTag}>
      {colorMap?.[status]?.text}
    </div>
  );
}

export default UsageRequestTag;
